const Footer = () => {
    return (
        <div className="mt-10 overflow-hidden z-20 w-full p-4 bg-white shadow-inner shadow-gray-500 md:flex md:items-center md:justify-between md:p-6 h-12 dark:bg-gray-800 dark:border-gray-600 ">
            <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">Copyright &copy; {new Date().getFullYear()} by Hunt Jobs All Rights Reserved.
            </span>
        </div>
        // <div className="border border-slate-300">
        //     <div>Copyright &copy; {new Date().getFullYear()} by Hunt Jobs All Rights Reserved.</div>
        // </div>
    )
}
export default Footer;